import axios, { AxiosRequestConfig } from 'axios';

export const apiClient = axios.create({
  baseURL: (process.env.REACT_APP_KLT_BASE_API_URL || window.location.protocol + '//' + window.location.host) + '/api/',
});

apiClient.interceptors.request.use((config: AxiosRequestConfig) => {
  config.withCredentials = true;
  return config;
});
